.tooltip {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1100;
  display: grid;
  column-gap: 20px;
  padding: 8px 12px 12px;
  border: 1px solid var(--gray-300);
  border-radius: 8px;
  background: var(--surface-elevated);
  box-shadow: 0 4px 16px rgb(0 0 0 / 12%);
  font-size: 13px;
  line-height: 24px;
  max-width: calc(100vw - 16px);
  white-space: nowrap;
  pointer-events: none;
}

.time {
  grid-column: 1 / -1;
  color: var(--text-tertiary);
  margin-bottom: 4px;
  line-height: 20px;
}

.device,
.value,
.missing {
  text-align: right;
}

.device {
  align-self: end;
  padding-top: 8px;
  font-weight: 500;
  line-height: 16px;
  white-space: normal;
}

.label {
  color: var(--text-secondary);
}

.value {
  font-weight: 600;
}

.missing {
  color: var(--text-tertiary);
}
